<template>

  <div>
    <modal />
    <transition name="fade">
      <router-view></router-view>
    </transition>

    <transition name="fadePro">
        <div id="myModal" class="modal" v-show='showProgress' @click="closePopup">
          <div></div>
          <div class="modal-content">
           <div class="loader"> </div>
          </div>
        </div>
    </transition>

    <transition name="fadePopup">
      <div id="myModalPopup"  v-show='popupVisible' @click='clickOut' >
        <div id='back-popup'>
        </div>
        <div class="modal-content-mainpopup">
          <div id='textoContainer-mainpopup'>
            <p id='texto-mainpopup'>{{popupTxt}}</p>
          </div>
          <div id='btnContainer-mainpopup'>
            <button id='mainpopupBtn1' @click='btnCancel' v-show='popupTxtBtnCancelVisible'>{{popupTxtBtnCancel}}</button>
            <button id='mainpopupBtn2' @click='btnOk'>{{popupTxtBtnOk}}</button>
          </div>
        </div>
      </div>
    </transition>

  </div>

</template>

<script>
import '@assets/sheets/main.css'
import 'picasso.css/dist/build.min.css'
import modal from '@components/layouts/modal.vue'

export default {
  name: 'App',
  components: { modal },
  computed: {

    showProgress () {
      return this.$store.state.loader.visible;
    },

    popupVisible () {
      return this.$store.state.popup.popupVisible
    },

    popupTxt () {
      return this.$store.state.popup.texto
    },

    popupTxtBtnCancel () {
      return this.$store.state.popup.txtBtnCancel
    },

    popupTxtBtnOk () {
      return this.$store.state.popup.txtBtnOk
    },

    popupTxtBtnCancelVisible () {
      if (this.$store.state.popup.txtBtnCancel == '')
      {
        return false
      }
      else
      {
        return true
      }
    }
  },


  methods:
  {
    btnCancel() {
      this.$store.commit('popup/btnCancel');
    },
    btnOk() {
      this.$store.commit('popup/btnOk');
    },
    clickOut() {
      this.$store.commit('popup/close');
    },
    closePopup() {
      this.$store.commit("loader/stop");
    }
  }

}




</script>

<style>

*{
  margin:  0;
  padding: 0;
}

.datepicker-ic{
  background-color: #ffffff;
  border: none;
  height: 28px;
  width: 335px;
  }

#back-popup {
 position: absolute;
 top: 0;
 left: 0;
 width: 100%;
 height: 100vh;
 background: #000000;
 opacity: 0.5;
}



.modal-content-mainpopup {
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
width: 300px;
border-radius:15px;
background-color: #ffffff;
display: flex;
flex-direction: column;
align-items: center;
}



#textoContainer-mainpopup {
background: #ffffff;
width: 90%;
padding-top: 25px;
padding-bottom: 10px;
display: flex;
flex-direction: row;
justify-content: center;
}


#texto-mainpopup {
font-size: 16px;
color: #000000;
text-align: center;
}


#btnContainer-mainpopup {
 width: 90%;
 height: 65px;
 background: #ffffff;
 display: flex;
 flex-direction: row;
 justify-content: center;
 align-items: center;
}


#mainpopupBtn1 {
  margin-right: 5px;
  height: 30px;
  padding-left: 12px;
  padding-right: 12px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 20px;
  border-style: solid;
  border:none;
  text-align: center;
  height: 30px;
  color: #5c666f;
  background: #ffffff;
  border-width: 1px;
  border: 2px solid #5c666f;
  outline: none;
}


#mainpopupBtn2 {
  /*width: 100%;*/
  margin-left: 5px;
  height: 30px;
  padding-left: 12px;
  padding-right: 12px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 20px;
  border-style: solid;
  border:none;
  text-align: center;
  /*width: 80px;*/
  background: #005A9F;
  color: #ffffff;
  border-width: 1px;
  border: 2px solid #005A9F;
  outline: none;
}

#mainpopupBtn1:hover { cursor: pointer; }
#mainpopupBtn2:hover { cursor: pointer; }

.modal {
 position: absolute;
 top: 0;
 left: 0;
 width: 100%;
 height: 100vh;
 background: #000000;
 opacity: 0.5;
}

/* Modal Content */
.modal-content {
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
width: 100px;
height: 100px;
background-color: #000000;
display: flex;
justify-content: center;
align-items: center;
}


.loader {
  border: 8px solid #f3f3f3;
  border-radius: 100%;
  border-top: 8px solid #3498db;
  width: 50px;
  height: 50px;
  -webkit-animation: spin 1s linear infinite; /* Safari */
  animation: spin 1s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0}




.fadePro-enter {
  opacity: 0;
}
.fadePro-enter-active {
  transition: opacity 0.5s;
}
.fadePro-enter-to {
  opacity: 0.5;
}
.fadePro-leave {
  opacity: 0.5;
}
.fadePro-leave-active {
  transition: opacity 0.5s;
}
.fadePro-leave-to {
  opacity: 0;
}


.fadePopup-enter {
  opacity: 0;
}
.fadePopup-enter-active {
  transition: opacity 0.5s;
}
.fadePopup-enter-to {
  opacity: 1;
}
.fadePopup-leave {
  opacity: 1;
}
.fadePopup-leave-active {
  transition: opacity 0s;
}
.fadePopup-leave-to {
  opacity: 0;
}

</style>




// WEBPACK FOOTER //
// src/app.vue